







































































































































































































































































































































































































import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class CoinRotateBottomLargeIcon extends Vue {
  @Prop({ default: '224' }) readonly width?: string;
  @Prop({ default: '226' }) readonly height?: string;
}
